import { Form } from '@domain-group/suit-theme'

import { UseCampaignFormPayload } from '@hooks/useCampaign'
import useSelector from '@hooks/useSelector'

import SuburbSearch from '@components/SuburbSearch'

import type { GeoSuburbModel } from '@models/types'

import { EntitiesState } from '@redux/entities'

type HandleSelectSuburbParams = {
  geoStates: EntitiesState['geoStates'],
  geoSuburb: GeoSuburbModel,
  setEntityState: UseCampaignFormPayload['setEntityState'],
}

const handleSelectSuburb = (params: HandleSelectSuburbParams) => {
  const { geoStates, geoSuburb, setEntityState } = params

  setEntityState({
    country_code: geoStates[geoSuburb.geo_state_id]?.country_code,
    post_code: geoSuburb?.post_code,
    state_id: geoSuburb?.geo_state_id,
    state_name: geoStates[geoSuburb.geo_state_id]?.code,
    suburb_id: geoSuburb?.id,
    suburb_name: geoSuburb?.title,
  })
}

const AddressForm = (props: {campaignFormPayload: UseCampaignFormPayload}) => {
  const { campaignFormPayload } = props

  const {
    entityState: {
      agency_id,
      post_code,
      state_name,
      street_name,
      street_number,
      suburb_name,
      unit_number,
    },
    errors,
    handlers,
    setEntityState,
  } = campaignFormPayload

  const { agencies, geoStates } = useSelector(reduxState => reduxState.entities)

  const agency = agencies[agency_id]
  const { geo_country_id } = agency

  return (
    <>
      <Form.Row marginTop="large">
        <Form.Field label="Unit No.">
          <input
            name="unit_number"
            type="text"
            value={unit_number}
            {...handlers}
          />
        </Form.Field>

        <Form.Field errorMessage={errors.street_number} label="* Street No.">
          <input
            name="street_number"
            type="text"
            value={street_number}
            {...handlers}
          />
        </Form.Field>
      </Form.Row>

      <Form.Field errorMessage={errors.street_name} label="* Street Name" marginTop="large">
        <input
          data-test-id="inputStreetName"
          name="street_name"
          type="text"
          value={street_name}
          {...handlers}
        />
      </Form.Field>

      <Form.Field errorMessage={errors.suburb_name} label="* Suburb Name" marginTop="large">
        <SuburbSearch
          callbacks={{
            onChange: (value: string) => setEntityState({ suburb_name: value }),
            selectItem: (geoSuburb: GeoSuburbModel) => handleSelectSuburb({ geoStates, geoSuburb, setEntityState }),
          }}
          requestOptions={{ geo_country_id }}
          value={suburb_name}
        />
      </Form.Field>

      <Form.Row marginTop="large">
        <Form.Field errorMessage={errors.state_name} label="* State">
          <input
            name="state_name"
            type="text"
            value={state_name}
            {...handlers}
          />
        </Form.Field>

        {/*
         // @ts-expect-error TS2322 */}
        <Form.Field errorMessage={errors.post_code} label="* Postcode" marginTop={['large', 0]}>
          <input
            name="post_code"
            value={post_code}
            type="text"
            {...handlers}
          />
        </Form.Field>
      </Form.Row>
    </>
  )
}

export default AddressForm
